import React from 'react';

const LanguageContext = React.createContext('en');

export default LanguageContext;
